<template>
    <div class="card classPlanStudent">
        <h4 style="margin-left: 20px">学生签到情况:</h4>
        <div class="card-body" >
            <el-row :gutter="20">
                <el-col :span="12">上课日期：{{parentInfo.component_classPlanStudent.classPlan.date}}</el-col>
                <el-col :span="12">班级：{{parentInfo.component_classPlanStudent.classPlan.class_name}}</el-col>
            </el-row>
            <el-row style="margin-bottom: 30px">
                <el-col :span="12">上课老师：{{parentInfo.component_classPlanStudent.classPlan.teacherName}}</el-col>
                <el-col :span="12"> 上课时间：{{parentInfo.component_classPlanStudent.classPlan.start_time}}-{{parentInfo.component_classPlanStudent.classPlan.end_time}}</el-col>

            </el-row>
            <hr>
            <div v-for="classPlanStudent in parentInfo.component_classPlanStudent.classPlanStudents ">
                <el-row :gutter="20" style="margin-bottom: 20px">
                    <el-col :span="12">姓名：{{classPlanStudent.student}}</el-col>
                    <el-col :span="12">签到状态：{{classPlanStudent.status}}</el-col>
                </el-row>
            </div>
            <hr>
            <el-row :gutter="20">
                <el-col :span="12">课程在购物车学生：</el-col>
            </el-row>
            <div v-for="classPlanCartStudent in parentInfo.component_classPlanStudent.classPlanCartStudents">
                <el-row :gutter="20" style="margin-bottom: 20px">
                    <el-col :span="12">姓名：{{classPlanCartStudent.student}}</el-col>
                    <el-col :span="12">签到状态：{{classPlanCartStudent.status}}</el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ClassPlanStudent",
        data() {
            return {
            }
        },
        created() {
            this.parentInfo = this.$parent.$parent.$parent;
            this.handleGetClassPlanStudents();
        },
        props: {
            classPlan_id: '',
            date:'' ,
        },
        methods: {
            handleGetClassPlanStudents(){
                this.$wApi.send(this.parentInfo.path, 'get_classPlanStudents', {
                    'classPlan_id': this.classPlan_id,
                });
            },
        }
    }

</script>

<style scoped>
    .classPlanStudent{
        width: 420px;
        height: 700px;
        border-radius:10px;
        box-shadow:0px 1px 20px #D37A3F;
        overflow: auto;
    }
</style>
